import { useState, useEffect, useContext } from 'react';
import { Paper, Box, Container, Grid, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AppContext } from '../../sporttia/all';
import LogoHeading from '../../layout/LogoHeading';

type User = {
    id: number;
    name?: string;
    email?: string;
};

type LocationState = {
    user?: User;
};

export default function ConfirmEmail(): React.ReactElement {
    const cxt = useContext(AppContext)!;
    const { t } = useTranslation();
    const location = useLocation();
    const [user, setUser] = useState<User | undefined>();

    // On component mount, we load the user from the state passed in the location
    useEffect(() => {
        const state = location.state as LocationState;
        if (state?.user) {
            setUser(state.user);
        }
    }, [location]);

    function send() {
        if (!user) {
            cxt?.showMessage('E', t('confirmEmail.invalid'));
            return;
        }

        cxt?.api('POST', `/users/emails/confirmations`, {
            params: {
                idUser: user.id,
            },
            success: (result: { email?: string }) => {
                if (result.email) {
                    cxt.showMessage('S', t('view.recoverPassword.sendEmail'));
                }
            },
        });
    }

    return (
        <Container maxWidth="sm">
            <Box mt={6}>
                <Paper>
                    <Box p={8}>
                        <Grid container spacing={3}>
                            <Grid size={{ xs: 12 }}>
                                <LogoHeading
                                    caption={t('confirmEmail.title')}
                                />
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body1">
                                    {t('confirmEmail.emailSent1')}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Typography variant="body1">
                                    {t('confirmEmail.emailSent2')}
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12 }}>
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Box textAlign="center">
                                            <Link
                                                style={{ cursor: 'pointer' }}
                                                href="/login"
                                            >
                                                <Typography variant="body1">
                                                    {t('login.signIn')}
                                                </Typography>
                                            </Link>
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6 }}>
                                        <Box textAlign="center">
                                            <Link
                                                style={{ cursor: 'pointer' }}
                                                onClick={send}
                                            >
                                                <Typography variant="body1">
                                                    {t(
                                                        'confirmEmail.emailSent3',
                                                    )}
                                                </Typography>
                                            </Link>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </Container>
    );
}
